import React, { useContext } from "react"
import { Link } from "react-router-dom"
import { LanguageContext } from "../context"

const NotFoundPage = () => {

  const { t } = useContext(LanguageContext)

  return (
    <div>
      <div className="content-parent">
        <div className="flex flex-col justify-center">
          <h4 className="event-title !text-center">{t('generic.not_found')}</h4>
          <div className="mt-6 flex justify-center">
            <Link to="/"><button className="btn">{t('generic.return_to_home')}</button></Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
